'use strict';

var VIEW_MODES = {
  SHOPPER: 'shopper',
  CREATOR: 'creator'
};

var REGION_TYPES = {
  IMAGE: 'picture',
  TEXT: 'text',
  TEXT_AREA: 'text_area'
};

var BREAKPOINT_SIZES = {
  DESKTOP: {
    HEIGHT: 417,
    WIDTH: 626
  }
};

module.exports = {
  BREAKPOINT_SIZES: BREAKPOINT_SIZES,
	EMBOSS: 'embossed',
	ENGRAVE: 'engraved',
  IMAGE: REGION_TYPES.IMAGE,
  TEXT: REGION_TYPES.TEXT,
  TEXT_AREA: REGION_TYPES.TEXT_AREA,
  TEXT_FORMAT_MULTI: 'MULTI',
  SELECTED_CLASS: 'sw-customization-region-sidebar__region-nav-item-selected',
  DISABLE_CLASS: 'disabled',
  HIDDEN_CLASS: 'sw--is-hidden',
  VIEW_MODES: VIEW_MODES,
  ENGRAVE_DEFAULTS: {
    DEPTH: 0.7,
    MIN: 0.3,
    MAX: 3.5,
    STEP_SIZE: 0.1,
    ENGRAVE_MULTIPLIER: -1,
    EMBOSS_MULTIPLIER: 1
  },
  SHAPE_JS_PREFIX: 'shapeJS_',
  INIT_DATA: {
    id: '',
    boxMode: null,
    formActions: {
      baseAction: '',
      customizedAction: ''
    },
    isPreviewing: true,
    hotspots: {},
    currentHotspotId: -1,
    modelId: -1,
    model: undefined,
    modelRotation: undefined,
    preventAllInput: false,
    resolution: 0.2,
    waitingForViewer: false,
    viewMode: VIEW_MODES.SHOPPER
  }
};
